import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { getUserProfileLog } from '../gql'
import LoadingIndicator from '../../../../../Components/LoadingIndicator/LoadingIndicator'
import { DATETIME_PICKER_FORMAT } from '../../../../../constants'
import { dateFormatter } from '../../../../../Utils/Formatters'
import { LinkView } from '../../../../../Components/Link/View'
import { USER_PROFILE_LOGS_LABELS } from '../../../../../shared/constants'

const styles = {
  table: {
    paddingBottom: 30,
    maxHeight: '60vh',
    overflow: 'auto',
  },
}

const HistoryLogTable = ({ ambassadorId, hideModal }) => {
  const [state, setState] = useState({ logs: [], isLoading: true })
  const classes = makeStyles(() => styles)()

  useEffect(() => {
    const getLogs = async () => {
      const { data } = await getUserProfileLog({
        profile_user_id: ambassadorId,
      }).then(result => result.json())
      setState({ logs: data.getUserProfileLog, isLoading: false })
    }
    getLogs()
  }, [])

  return state.isLoading ? (
    <LoadingIndicator />
  ) : state.logs.length ? (
    <TableContainer className={classes.table}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Timestamp</TableCell>
            <TableCell>Actioned by</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {state.logs.map((log, index) => {
            const {
              actioned_by_user_id,
              type,
              created_at,
              actioned_first_name,
              actioned_last_name,
            } = log
            return (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  {dateFormatter(
                    parseInt(created_at, 10),
                    DATETIME_PICKER_FORMAT,
                  )}
                </TableCell>
                <TableCell>
                  <LinkView
                    to={`/dashboard/users/${actioned_by_user_id}`}
                    label={`${actioned_first_name} ${actioned_last_name}`}
                    onClick={hideModal}
                  />
                </TableCell>
                <TableCell>{USER_PROFILE_LOGS_LABELS[type]}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    'No data'
  )
}

export default HistoryLogTable
